
import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";

const About = () => {
  const teamMembers = [
    {
      name: "Emily Johnson",
      role: "Founder & CEO",
      bio: "Former career counselor with 10+ years experience connecting students with alumni mentors.",
      image: "/placeholder.svg"
    },
    {
      name: "Michael Chen",
      role: "CTO",
      bio: "Tech leader who built mentorship platforms for top universities before joining Alumni Insights.",
      image: "/placeholder.svg"
    },
    {
      name: "Sarah Williams",
      role: "Director of Alumni Relations",
      bio: "Previously led alumni engagement at Stanford University, connecting thousands of graduates annually.",
      image: "/placeholder.svg"
    },
    {
      name: "David Rodriguez",
      role: "Head of Student Success",
      bio: "Career counseling expert who helped over 5,000 students secure their dream jobs.",
      image: "/placeholder.svg"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-white font-montserrat">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8">
        <section className="mb-16">
          <div className="text-center mb-10">
            <h1 className="font-playfair text-4xl font-bold text-crimson mb-4">About Alumni Insights</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Connecting students with experienced alumni to help shape their educational and career paths
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <h2 className="font-playfair text-2xl font-bold mb-4">Our Mission</h2>
              <p className="mb-4 text-gray-700">
                Alumni Insights was founded with a simple yet powerful mission: to bridge the gap between academic education and real-world careers through meaningful alumni-student connections.
              </p>
              <p className="mb-4 text-gray-700">
                We believe that experienced alumni are an invaluable resource for students navigating their educational and career paths. By facilitating these connections, we help students make more informed decisions and alumni give back to their communities.
              </p>
              <p className="text-gray-700">
                Our platform enables personalized guidance that goes beyond generic career advice, creating lasting mentor relationships that benefit both parties.
              </p>
            </div>
            <div>
              <img 
                src="/placeholder.svg" 
                alt="Students and alumni connecting"
                className="rounded-lg shadow-lg w-full"
              />
            </div>
          </div>
        </section>
        
        <section className="mb-16">
          <h2 className="font-playfair text-3xl font-bold text-center mb-10">Our Story</h2>
          <div className="max-w-4xl mx-auto">
            <p className="mb-4 text-gray-700">
              Alumni Insights began in 2022 when our founder, Emily Johnson, recognized a critical gap in higher education: while universities had robust alumni networks, there was no efficient way for current students to connect with graduates for personalized guidance.
            </p>
            <p className="mb-4 text-gray-700">
              As a career counselor, Emily saw firsthand how students struggled to make informed decisions about their majors, internships, and career paths. She also knew how many alumni wished they had received better guidance during their own studies.
            </p>
            <p className="mb-4 text-gray-700">
              The platform started as a small pilot program at three universities, connecting 50 students with alumni mentors. The results were transformative – students reported greater clarity about their career paths, while alumni found deep satisfaction in sharing their expertise.
            </p>
            <p className="text-gray-700">
              Today, Alumni Insights connects thousands of students with alumni across hundreds of educational institutions, creating valuable relationships that help shape the next generation of professionals.
            </p>
          </div>
        </section>
        
        <section className="mb-16">
          <h2 className="font-playfair text-3xl font-bold text-center mb-10">Our Team</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {teamMembers.map((member, index) => (
              <Card key={index} className="overflow-hidden">
                <img 
                  src={member.image} 
                  alt={member.name} 
                  className="w-full h-48 object-cover"
                />
                <CardContent className="pt-4">
                  <h3 className="font-bold text-lg">{member.name}</h3>
                  <p className="text-crimson mb-2">{member.role}</p>
                  <p className="text-sm text-gray-600">{member.bio}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </section>
        
        <section className="mb-16">
          <h2 className="font-playfair text-3xl font-bold text-center mb-10">Our Impact</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-crimson mb-2">10,000+</div>
              <p className="text-xl">Students Connected</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-crimson mb-2">2,500+</div>
              <p className="text-xl">Alumni Mentors</p>
            </div>
            <div>
              <div className="text-4xl font-bold text-crimson mb-2">95%</div>
              <p className="text-xl">Satisfaction Rate</p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default About;
